import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const DateContext = createContext({
  checkIn: null,
  checkOut: null,
  setCheckIn: () => {},
  setCheckOut: () => {},
  hasDates: false,
  formatDate: (date) => '',
});

export const DateProvider = ({ children }) => {
  const [checkIn, setCheckInState] = useState(() => {
    try {
      const saved = localStorage.getItem('checkIn');
      return saved ? new Date(saved) : null;
    } catch {
      return null;
    }
  });

  const [checkOut, setCheckOutState] = useState(() => {
    try {
      const saved = localStorage.getItem('checkOut');
      return saved ? new Date(saved) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    try {
      if (checkIn) {
        localStorage.setItem('checkIn', checkIn.toISOString());
      } else {
        localStorage.removeItem('checkIn');
      }
    } catch {}
  }, [checkIn]);

  useEffect(() => {
    try {
      if (checkOut) {
        localStorage.setItem('checkOut', checkOut.toISOString());
      } else {
        localStorage.removeItem('checkOut');
      }
    } catch {}
  }, [checkOut]);

  const setCheckIn = (date) => {
    if (date instanceof Date) {
      setCheckInState(date);
    } else if (typeof date === 'string') {
      setCheckInState(new Date(date));
    } else {
      setCheckInState(null);
    }
  };

  const setCheckOut = (date) => {
    if (date instanceof Date) {
      setCheckOutState(date);
    } else if (typeof date === 'string') {
      setCheckOutState(new Date(date));
    } else {
      setCheckOutState(null);
    }
  };

  const hasDates = checkIn !== null && checkOut !== null;

  const formatDate = (date) => {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    return d.toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const value = useMemo(
    () => ({
      checkIn,
      checkOut,
      setCheckIn,
      setCheckOut,
      hasDates,
      formatDate,
    }),
    [checkIn, checkOut, hasDates]
  );

  return <DateContext.Provider value={value}>{children}</DateContext.Provider>;
};

export const useDate = () => useContext(DateContext);





